module.exports = __webpack_public_path__ + "static/img/w3-3.c616406.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd102/w3-3.png
// module id = sg5h
// module chunks = 1